import { FEATURES, PRODUCT_FAMILY, PRODUCTS } from '@/base/constants/authorization'

export const compassExploreAccessRule = {
  $and: [
    {
      $or: [
        { product: { $eq: PRODUCT_FAMILY.COMPASS } },
        { product: { $eq: PRODUCT_FAMILY.ASO } },
      ],
    },
    {
      $or: [
        { name: { $eq: PRODUCTS.COMPASS } },
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_COMPASS_EXPLORE },
        },
      },
    },
  ],
}

export const compassTraceAccessRule = {
  $and: [
    {
      $or: [
        { product: { $eq: PRODUCT_FAMILY.COMPASS } },
        { product: { $eq: PRODUCT_FAMILY.ASO } },
      ],
    },
    {
      $or: [
        { name: { $eq: PRODUCTS.COMPASS } },
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_COMPASS_TRACE },
        },
      },
    },
  ],
}

export const compassImpactAccessRule = {
  $and: [
    {
      $or: [
        { product: { $eq: PRODUCT_FAMILY.COMPASS } },
        { product: { $eq: PRODUCT_FAMILY.ASO } },
      ],
    },
    {
      $or: [
        { name: { $eq: PRODUCTS.COMPASS } },
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_COMPASS_IMPACT },
        },
      },
    },
  ],
}

export const appProfileAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_APP_PROFILE },
        },
      },
    },
  ],
}

export const publisherProfileAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_PUBLISHER_PROFILE },
        },
      },
    },
  ],
}

export const featuredAppsAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_FEATURED_APPS },
        },
      },
    },
  ],
}

export const categoryRankingsAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_CATEGORY_RANKINGS },
        },
      },
    },
  ],
}

export const reviewsAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_REVIEW_ANALYSIS },
        },
      },
    },
  ],
}

export const ratingsAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_RATING },
        },
      },
    },
  ],
}

export const similarAppsAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_SIMILAR_APPS },
        },
      },
    },
  ],
}

export const salesMetricsAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_SALES_METRICS },
        },
      },
    },
  ],
}

export const inAppEventsAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_IN_APP_EVENTS },
        },
      },
    },
  ],
}

export const promotionalContentAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_PROMOTIONAL_CONTENT },
        },
      },
    },
  ],
}

export const topChartsAccessRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_LITE } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_TOP_CHARTS },
        },
      },
    },
  ],
}
export const biggestMoversAccessRule = topChartsAccessRule
export const biggestLosersAccessRule = topChartsAccessRule
export const newAppsAccessRule = topChartsAccessRule
